import { Link } from "react-router-dom";
import { InkHeading } from "./InkHeading";
import { SiteLinks } from "./SiteLinks";
import { SiteFooter } from "./SiteFooter";
import { track } from "@/lib/analytics";

export function Home() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-5 pt-8 pb-12">
      <article className="w-full max-w-[680px] bg-white/85 backdrop-blur-[1px] px-8 pt-9 pb-10 relative animate-ink-in">
        <div className="h-4" />

        <section>
          <p className="text-[1.02rem] mb-0">Hi, I'm</p>
          <InkHeading />
          <p className="text-[1.02rem]">
            I build robots and the systems around them, from data pipelines to
            the platforms people use to run them.
          </p>

          <p className="text-[rgba(31,29,25,0.62)]">
            My work spans robot learning, simulation, and systems engineering,
            including projects at AWS and RWTH Aachen. I also co-founded
            Robotics Collective Aachen.
          </p>
        </section>

        <div className="h-2" />

        <nav
          aria-label="Site sections"
          className="flex gap-6 text-[0.9rem] caps-label text-[rgba(31,29,25,0.7)] mb-4"
        >
          <Link
            viewTransition
            to="/projects"
            onClick={() => track("portfolio_cta", { source: "home" })}
            className="border-b border-transparent transition-colors duration-150 hover:text-[#7b5b33] hover:border-[#7b5b33]"
          >
            Projects
          </Link>
        </nav>

        <nav aria-label="Social and contact links">
          <SiteLinks />
        </nav>
      </article>
      <SiteFooter />
    </main>
  );
}
